import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Input, Label, Row } from "reactstrap"
import { FaPlus, FaX } from "react-icons/fa6"
import Swal from "sweetalert2"
import { fetchData, FetchPostData } from "utils/Common_api_functions"

const AddUserModal = ({ setclose }) => {
  const [clubData, setClubData] = useState([])
  const [planData, setPlanData] = useState([])
  const [loading, setloading] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const [errors, setErrors] = useState({})

  useEffect(() => {
    getClubs()
  }, [])

  async function getClubs() {
    const APIData2 = await fetchData(setloading, "pricing/plan")
    const APIdata = await fetchData(setloading, "club")

    setPlanData(
      APIData2.userPlans?.map(item => ({
        label: item?.planName,
        value: item?._id,
      }))
    )

    setClubData(
      APIdata?.clubs?.map(item => ({
        label: item?.clubName,
        value: item?._id,
      }))
    )
  }

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    club: "",
    birthdate: "",
    gender: "",
    country: "",
    postcode: "",
    trainingStartDate: "",
    plan: "",
  })

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    setErrors(prev => ({ ...prev, [name]: "" })) // clear error while typing
  }

  const validateForm = () => {
    const newErrors = {}

    if (!formData.name.trim()) newErrors.name = "Name is required"
    if (!formData.email.trim()) newErrors.email = "Email is required"
    if (!formData.club) newErrors.club = "Club is required"
    if (!formData.birthdate) newErrors.birthdate = "Birthdate is required"
    if (!formData.gender) newErrors.gender = "Gender is required"
    if (!formData.plan) newErrors.plan = "Plan is required"
    if (!formData.trainingStartDate)
      newErrors.trainingStartDate = "Training start date is required"
    if (!formData.country.trim()) newErrors.country = "Country is required"
    if (!formData.postcode.trim()) newErrors.postcode = "Postcode is required"

    setErrors(newErrors)

    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async () => {
    setSubmitted(true)

    if (!validateForm()) {
      Swal.fire({
        title: "Please fill all required fields.",
        icon: "warning",
      })
      return
    }

    const APIData = await FetchPostData(setloading, "user/by/admin", formData)

    if (APIData?.data?.success) {
      Swal.fire({
        title: "User Created Successfully.",
        icon: "success",
      })
      setclose(false)
    } else {
      Swal.fire({
        title: "Something went Wrong",
        icon: "error",
      })
    }
  }

  return (
    <Row>
      <Col lg="12">
        <Card className="mb-0">
          <CardBody className="p-0">
            <Row>
              <Col md="4">
                <Label>Name <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder={
                    submitted && errors.name ? "At Risk" : "Enter full name"
                  }
                  className={errors.name ? "is-invalid" : ""}
                />
                {errors.name && (
                  <small className="text-danger">{errors.name}</small>
                )}
              </Col>

              <Col md="4">
                <Label>Email <span className="text-danger">*</span></Label>
                <Input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder={
                    submitted && errors.email ? "At Risk" : "Enter email"
                  }
                  className={errors.email ? "is-invalid" : ""}
                />
                {errors.email && (
                  <small className="text-danger">{errors.email}</small>
                )}
              </Col>

              <Col md="4">
                <Label>Select Club <span className="text-danger">*</span></Label>
                <Input
                  type="select"
                  name="club"
                  value={formData.club}
                  onChange={handleChange}
                  className={errors.club ? "is-invalid" : ""}
                >
                  <option value="">
                    {submitted && errors.club ? "At Risk" : "Select Club"}
                  </option>
                  {clubData.map(club => (
                    <option key={club.value} value={club.value}>
                      {club.label}
                    </option>
                  ))}
                </Input>
                {errors.club && (
                  <small className="text-danger">{errors.club}</small>
                )}
              </Col>
            </Row>

            <Row className="mt-4">
              <Col md="4">
                <Label>Birth Date <span className="text-danger">*</span></Label>
                <Input
                  type="date"
                  name="birthdate"
                  value={formData.birthdate}
                  onChange={handleChange}
                  className={errors.birthdate ? "is-invalid" : ""}
                />
                {errors.birthdate && (
                  <small className="text-danger">{errors.birthdate}</small>
                )}
              </Col>

              <Col xl="4">
                <Label>Gender <span className="text-danger">*</span></Label>
                <Input
                  type="select"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  className={errors.gender ? "is-invalid" : ""}
                >
                  <option value="">
                    {submitted && errors.gender ? "At Risk" : "Select Gender"}
                  </option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="nonbinary">Non-Binary</option>
                  <option value="prefer_not_say">Prefer not to say</option>
                  <option value="other">Other</option>
                </Input>
                {errors.gender && (
                  <small className="text-danger">{errors.gender}</small>
                )}
              </Col>

              <Col xl="4">
                <Label>Plan <span className="text-danger">*</span></Label>
                <Input
                  type="select"
                  name="plan"
                  value={formData.plan}
                  onChange={handleChange}
                  className={errors.plan ? "is-invalid" : ""}
                >
                  <option value="">
                    {submitted && errors.plan ? "At Risk" : "Select Plan"}
                  </option>
                  {planData?.map(item => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Input>
                {errors.plan && (
                  <small className="text-danger">{errors.plan}</small>
                )}
              </Col>

              <Col md="4" className="mt-4">
                <Label>Training Start Date <span className="text-danger">*</span></Label>
                <Input
                  type="date"
                  name="trainingStartDate"
                  value={formData.trainingStartDate}
                  onChange={handleChange}
                  className={errors.trainingStartDate ? "is-invalid" : ""}
                />
                {errors.trainingStartDate && (
                  <small className="text-danger">
                    {errors.trainingStartDate}
                  </small>
                )}
              </Col>

              <Col md="4" className="mt-4">
                <Label>Country <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  placeholder={
                    submitted && errors.country ? "At Risk" : "Enter country"
                  }
                  className={errors.country ? "is-invalid" : ""}
                />
                {errors.country && (
                  <small className="text-danger">{errors.country}</small>
                )}
              </Col>

              <Col md="4" className="mt-4">
                <Label>Postcode <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  name="postcode"
                  value={formData.postcode}
                  onChange={handleChange}
                  placeholder={
                    submitted && errors.postcode ? "At Risk" : "Enter postcode"
                  }
                  className={errors.postcode ? "is-invalid" : ""}
                />
                {errors.postcode && (
                  <small className="text-danger">{errors.postcode}</small>
                )}
              </Col>
            </Row>

            <div className="d-flex justify-content-end mt-3 align-items-center">
              <div className="d-flex gap-3">
                <button className="btn btn-add" onClick={handleSubmit}>
                  <FaPlus className="me-1" size={14} /> Submit
                </button>
                <button
                  className="btn bg-danger text-white"
                  onClick={() => setclose(false)}
                >
                  <FaX className="me-1" size={14} /> Cancel
                </button>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default AddUserModal
